import {once} from './core.js';

function value(cell) {
	const explicit = cell.dataset.sortValue;
	if (explicit !== undefined) {
		const numeric = Number(String(explicit).replace(',', '.'));
		return Number.isNaN(numeric) ? explicit : numeric;
	}
	return cell.textContent.trim().toLocaleLowerCase();
}

function bindSort(button) {
	if (!once(button, 'table-sort')) {
		return;
	}
	button.addEventListener('click', () => {
		const table = button.closest('table');
		const header = button.closest('th');
		const index = [...header.parentElement.children].indexOf(header);
		const ascending = header.getAttribute('aria-sort') !== 'ascending';
		const rows = [...table.tBodies[0].rows].map((row, originalIndex) => ({row, originalIndex}));
		rows.sort((left, right) => {
			const a = value(left.row.cells[index]);
			const b = value(right.row.cells[index]);
			const compared = typeof a === 'number' && typeof b === 'number' ? a - b : String(a).localeCompare(String(b), undefined, {numeric: true, sensitivity: 'base'});
			return (compared || left.originalIndex - right.originalIndex) * (ascending ? 1 : -1);
		});
		table.querySelectorAll('th[aria-sort]').forEach((item) => item.setAttribute('aria-sort', 'none'));
		header.setAttribute('aria-sort', ascending ? 'ascending' : 'descending');
		rows.forEach(({row}) => table.tBodies[0].append(row));
		if (table.id) {
			localStorage.setItem(`table-sort:${table.id}`, `${index}:${ascending ? 'asc' : 'desc'}`);
		}
	});
}

export function init(root = document) {
	root.querySelectorAll('[data-sort-table] thead th:not([data-sort-ignore])').forEach((header) => {
		if (!header.querySelector('button')) {
			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'table-sort__button';
			button.textContent = header.textContent.trim();
			header.replaceChildren(button);
		}
		header.setAttribute('aria-sort', header.getAttribute('aria-sort') || 'none');
		bindSort(header.querySelector('button'));
	});
}
